import {
  IReferral,
  IReferralMessage,
  ReferralCollection,
} from '@principle-theorem/principle-core/interfaces';
import {
  AtLeast,
  CollectionReference,
  Firestore,
  IReffable,
  WithRef,
  multiUndeleted,
  subCollection,
} from '@principle-theorem/shared';
import { Observable } from 'rxjs';

export class ReferralMessage {
  static init(
    overrides: AtLeast<IReferralMessage, 'content' | 'actor'>
  ): IReferralMessage {
    return {
      deleted: false,
      ...overrides,
    };
  }

  static col(
    referral: IReffable<IReferral>
  ): CollectionReference<IReferralMessage> {
    return subCollection<IReferralMessage>(
      referral.ref,
      ReferralCollection.Messages
    );
  }

  static all$(
    referral: IReffable<IReferral>
  ): Observable<WithRef<IReferralMessage>[]> {
    return Firestore.query$(ReferralMessage.col(referral)).pipe(
      multiUndeleted()
    );
  }
}
